const admin = {
    loadMenu: '/sys/auth/menu/list',
    getMenuResource: '/sys/auth/menu/info',
    saveMenuResource: '/sys/auth/menu/save',
    updateMenuResource: '/sys/auth/menu/update',
    deleteMenuResource: '/sys/auth/menu/delete',
    authMenuListParent:'/sys/auth/menu/listParent',
    sysUserPage: '/sys/user/page',
    authRolePage: '/sys/auth/role/page',
    authPermPage: '/sys/auth/perm/page',
    authPermOwnPermByUserRole: '/sys/auth/perm/ownPermByUserRole',
    sysUserAuthorization: '/sys/user/authorization',
    sysAuthRolePage: '/sys/auth/role/page',
    sysAuthMenuList: '/sys/auth/menu/list',
    sysAuthRoleRoleByUser: 'sys/auth/role/roleByUser',
    sysAuthRoleOnfo: '/sys/auth/role/info',
    sysAuthRoleDelete: '/sys/auth/role/delete',
    sysAuthRoleSave: '/sys/auth/role/save',
    sysAuthRoleUpdate: '/sys/auth/role/update',
    sysAuthRoleMenuList: '/sys/auth/role/menuList',
    sysAuthRoleSaveRoleMenu: '/sys/auth/role/saveRoleMenu',
    sysAuthPermPage: '/sys/auth/perm/page',
    sysAuthPermInfo: '/sys/auth/perm/info',
    sysAuthPermDelete: '/sys/auth/perm/delete',
    sysAuthPermSave: "/sys/auth/perm/save",
    sysAuthPermUpdate: "/sys/auth/perm/update",
    sysAuthPermGetDeptByPermId: '/sys/auth/perm/getDeptByPermId',
    sysAuthPermSavePermDept: '/sys/auth/perm/savePermDept',
    sysAuthPermList: '/sys/auth/perm/list',
    sysDictTypePage: '/sys/dict/type/page',
    sysDictTypeInfo: '/sys/dict/type/info',
    sysDictTypeSave: '/sys/dict/type/save',
    sysDictTypeUpdate: '/sys/dict/type/update',
    sysTemplateQueryPage: '/sys/template/page',
    sysTemplateSave: '/sys/template/save',
    sysTemplateUpdate: '/sys/template/update',
    sysTemplateDelete: '/sys/template/delete',
    sysDictDataPage: '/sys/dict/data/page',
    sysDictDataInfo: '/sys/dict/data/info',
    sysDictDataSave: '/sys/dict/data/save',
    sysDictDataUpdate: '/sys/dict/data/update',
    sysDictDataChange: '/sys/dict/data/change',

}

export default admin